import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import IdEntryPreview from "../pages/id-entry/IdEntryPreview";
import MileagePreview from "../pages/mileage/MileagePreview";
import CourseRecommendPreview from "../pages/course-recommend/CourseRecommendPreview";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <IdEntryPreview />,
  },
  {
    path: "/mileage",
    element: <MileagePreview />,
  },
  {
    path: "/course-recommend",
    element: <CourseRecommendPreview />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
